import styled from "styled-components";

export const FileWrapper = styled.div`
  > label {
    margin: 0;
    width: 100%;
    height: 100%;
    width: 416px;
    height: 196px;

    &:focus-within {
      outline: none;
    }
  }

  > p {
    margin: 0;
    margin-top: 8px;
    ${({ theme }) => theme.fontStyles.InterfaceCopy}
    color: ${({ theme }) => theme.colors.neutralsTextLight};
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
  }
`;

export const FileDropArea = styled.div`
  width: 100%;
  height: 100%;
  max-width: 416px;
  max-height: 196px;
  cursor: pointer;
  padding: 20px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;

  border-radius: 8px;
  border: 1px dashed ${({ theme }) => theme.colors.primaryTextHover};
  background: ${({ theme }) => theme.colors.neutralsBackgroundInactive};

  > img {
    width: 48px;
    height: 48px;
  }

  > p {
    margin: 0;
    ${({ theme }) => theme.fontStyles.DesktopCopyLargeBodyCopyBold}
    font-weight: 600;
    color: ${({ theme }) => theme.colors.primaryText};
  }
`;
